<section class="testimonials-section section-gap soft-blue-bg">
    <div class="container">
        <div class="section-title text-center mb-60">
            <span class="title-tag">Client Testimonials</span>
            <h2 class="title">What our clients say </h2>
        </div>
        <ngx-slick-carousel #slickModal="slick-carousel" [config]="settings" class="testimonials-slider row">
            <!-- Data -->
            <div ngxSlickItem class="col-lg-12" *ngFor="let item of testimonials">
                <div class="testimonial-box" [ngClass]="item.style">
                    <p>{{item.comment}}</p>
                    <div class="author d-flex align-items-center" *ngFor="let author of getAuthor(item.user)">
                        <div class="photo">
                            <img [src]="author.img" [alt]="author.name">
                        </div>
                        <div class="desc">
                            <h6>{{author.name}}</h6>
                            <span class="position">{{author.post}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Data -->
        </ngx-slick-carousel>
    </div>
</section>